var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorMsgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.148,
    height: 24.148,
    viewBox: "0 0 24.148 24.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-block",
    "data-name": "Icon material-block",
    d: "M15.074,3A12.074,12.074,0,1,0,27.148,15.074,12.079,12.079,0,0,0,15.074,3ZM5.415,15.074a9.657,9.657,0,0,1,9.659-9.659,9.541,9.541,0,0,1,5.916,2.041L7.455,20.991A9.541,9.541,0,0,1,5.415,15.074Zm9.659,9.659a9.541,9.541,0,0,1-5.916-2.041L22.693,9.158a9.541,9.541,0,0,1,2.041,5.916A9.657,9.657,0,0,1,15.074,24.734Z",
    transform: "translate(-3 -3)",
    fill: "#b73833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMsgIcon);
export default __webpack_public_path__ + "static/media/error_msg_icon.d3bdc7e82c908da5df08789470b42a98.svg";
export { ForwardRef as ReactComponent };